import React from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    FormGroup,
} from 'reactstrap';
import { ApiRoutes } from '../Common';
import { util } from '../Util';
import './JotFormModal.scss';

export const JotFormModalModes = {
    VIEW: 'view',
    SUBMIT: 'submit',
    EDIT: 'edit',
};

export default class JotFormModal extends React.Component {
    constructor(props) {
        super(props);
        const { modalMode, formSubmission } = this.props;

        const mode =
            modalMode ??
            (formSubmission?.status?.id === 1
                ? JotFormModalModes.SUBMIT
                : JotFormModalModes.VIEW);

        this.state = {
            formMessageSent: false,
            formSubmission: formSubmission,
            modalMode: mode
        };
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handleMessage);
    }

    componentDidUpdate(prevProps) {
        const { formSubmission, modalMode } = this.props;

        if (formSubmission?.id !== prevProps.formSubmission?.id) {
            this.setState({ formMessageSent: false, formSubmission });
        }

        if (!prevProps.isOpen && this.props.isOpen) {
            const mode =
                modalMode ??
                (formSubmission?.status?.id === 1
                    ? JotFormModalModes.SUBMIT
                    : JotFormModalModes.VIEW);

            this.setState({
                formMessageSent: false,
                formSubmission,
                modalMode: mode,
            });

            window.addEventListener('message', this.handleMessage, false);
        }

        if (prevProps.isOpen && !this.props.isOpen) {
            window.removeEventListener('message', this.handleMessage);
        }
    }

    handleMessage = async (event) => {
        if (!event.origin.includes('jotform.com')) return;

        const { formMessageSent, formSubmission, modalMode } = this.state;

        if (!formMessageSent) {
            this.handleJotFormIframeMessage(formSubmission);
        }
        if (event.data && event.data.action === 'submission-completed') {
            if (modalMode === JotFormModalModes.SUBMIT) {
                const updatedSubmission = await util.fetch.post(
                    ApiRoutes.jotForms.submit(formSubmission.id)
                );
    
                if (this.props.onSubmissionCompleted) {
                    this.props.onSubmissionCompleted(updatedSubmission);
                }
            }

            if (this.props.toggle) {
                this.props.toggle();
            }
        }
    };

    handleJotFormIframeMessage(formSubmission) {
        if (!formSubmission) return;
        const { modalMode } = this.state;
        const formId = formSubmission.jotForm && formSubmission.jotForm.formId;

        const jotFormIframe = document.getElementById(
            `JotFormIFrame-${formId}`
        );
        if (jotFormIframe) {
            const mode =
                modalMode ??
                (formSubmission?.status?.id === 1 ? 'submit' : 'edit');

            const url = window.location.href + `/jotform-${mode}`;
            const message = JSON.stringify({
                type: 'urls',
                value: { docurl: url },
            });
            jotFormIframe.contentWindow.postMessage(message, '*');
            this.setState({ formMessageSent: true });
        }
    }

    onEditClicked = async () => {
        const { formSubmission } = this.props;
        await util.fetch.js(
            ApiRoutes.jotForms.editPreJobFormSubmission(formSubmission.id)
        ).catch((err) => {
            console.log('Error trying to edit form', err);
        });

        this.setState(
            {
                formMessageSent: false,
                // formSubmission: newSubmission,
                modalMode: JotFormModalModes.EDIT,
            },
            () => {
                this.handleJotFormIframeMessage(formSubmission);
            }
        );
    };

    render() {
        const { isOpen, toggle } = this.props;
        const { formSubmission, modalMode } = this.state;
        const formId = formSubmission?.jotForm?.formId;
        const formTitle = formSubmission?.jotForm?.jotFormType?.description;
        const formAction = formSubmission?.status?.id === 1 ? 'Submit' : 'Edit';
        const formSrc = formId
            ? `https://form.jotform.com/jsform/${formId}`
            : ``;

        return (
            <Modal isOpen={isOpen} toggle={toggle} className="modal-fullscreen">
                <ModalHeader toggle={toggle}>
                    {formAction} {formTitle}
                </ModalHeader>
                <ModalBody className="p-0 modal-body-full">
                    <FormGroup style={{ height: '100%' }}>
                        {formSubmission &&
                        formSubmission.externalSubmissionUrl ? (
                            <>
                                <iframe
                                    id={`JotFormIFrame-${formId}`}
                                    title="Jot Form"
                                    allowTransparency="true"
                                    allowFullScreen
                                    allow="geolocation; microphone; camera; fullscreen"
                                    src={formSubmission.externalSubmissionUrl}
                                    style={{
                                        minWidth: '100%',
                                        maxWidth: '100%',
                                        height: '100%',
                                        border: 'none',
                                    }}
                                />
                                <script
                                    type="text/javascript"
                                    src={formSrc}
                                ></script>
                            </>
                        ) : (
                            <p>Loading form...</p>
                        )}
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    {modalMode == JotFormModalModes.VIEW && (
                        <Button color="danger" onClick={this.onEditClicked}>
                            Edit
                        </Button>
                    )}
                    <Button color="danger" onClick={toggle}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
